import { useEffect } from 'react';
import { AppState } from 'react-native';
import { getLastActivity, setActivityListener } from '@shared/utils/activityTracker';
import { clarityManager } from 'app/services/ClarityManager';
import Config from 'react-native-config';

const IDLE_TIMEOUT = 10 * 60 * 1000;

export const useClaritySession = ({clarityEnabled}:{clarityEnabled: boolean}) => {
  if (!clarityEnabled) return;

  useEffect(() => {
    if (!clarityEnabled) return
    const clarityProjectId = Config.CLARITY_PROJECT_ID;
    if (!clarityProjectId) {
      console.log('[Clarity] missing CLARITY_PROJECT_ID');
      return;
    }
    clarityManager.init(clarityProjectId);
  }, [clarityEnabled]);
  
  useEffect(() => {
    let idleTimer: ReturnType<typeof setTimeout> | null = null;

    const scheduleIdleCheck = () => {
      if (idleTimer) clearTimeout(idleTimer);

      const remaining = IDLE_TIMEOUT - (Date.now() - getLastActivity());

      if (remaining <= 0) {
        if (clarityManager.active) clarityManager.pause();
        return;
      }

      idleTimer = setTimeout(() => {
        if (clarityManager.active) clarityManager.pause();
      }, remaining);
    };

    const onActivity = () => {
      if (!clarityManager.active) clarityManager.resume();
      scheduleIdleCheck();
    };

    setActivityListener(onActivity);
    scheduleIdleCheck();

    const appStateSub = AppState.addEventListener('change', (state) => {
      if (state === 'active') {
        onActivity();
      } else {
        if (idleTimer) clearTimeout(idleTimer);
        clarityManager.pause();
      }
    });

    return () => {
      if (idleTimer) clearTimeout(idleTimer);
      setActivityListener(null);
      appStateSub.remove();
    };
  }, []);
};
